var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 11.1562C8.78516 11 9.09766 11 9.25391 11.1562L11.6602 13.5625C12.0977 14 12.6914 14.25 13.3164 14.25H13.7852L10.7539 17.2812C9.81641 18.2188 8.28516 18.2188 7.31641 17.2812L4.28516 14.25H4.56641C5.19141 14.25 5.78516 14 6.22266 13.5625L8.62891 11.1562ZM9.25391 8.84375C9.06641 9.03125 8.78516 9.03125 8.62891 8.84375L6.22266 6.46875C5.78516 6 5.19141 5.78125 4.56641 5.78125H4.28516L7.31641 2.71875C8.28516 1.78125 9.81641 1.78125 10.7539 2.71875L13.7852 5.75H13.3164C12.6914 5.75 12.0977 6 11.6602 6.4375L9.25391 8.84375ZM4.56641 6.46875C5.00391 6.46875 5.41016 6.65625 5.72266 6.96875L8.12891 9.34375C8.34766 9.5625 8.66016 9.6875 8.94141 9.6875C9.22266 9.6875 9.53516 9.5625 9.75391 9.34375L12.1602 6.9375C12.4727 6.65625 12.8789 6.46875 13.3164 6.46875H14.5039L16.3164 8.28125C17.2539 9.25 17.2539 10.7812 16.3164 11.7188L14.5039 13.5312H13.3164C12.8789 13.5312 12.4727 13.375 12.1602 13.0625L9.75391 10.6562C9.31641 10.2188 8.56641 10.2188 8.12891 10.6562L5.72266 13.0625C5.41016 13.3438 5.00391 13.5312 4.56641 13.5312H3.56641L1.75391 11.7188C0.816406 10.7812 0.816406 9.25 1.75391 8.28125L3.56641 6.46875H4.56641Z",
    fill: "#4BB8A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.7ec64c7651d226f4e7edb35117bf9235.svg";
export { ForwardRef as ReactComponent };